import styled from 'styled-components'

import Icon from '@/components/Icon'
import PricingCard, { PricingCardProps } from '@/components/PricingCard'
import { Slogan } from '@/components/Slogan'

const PricingPage = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 88px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
`

const Content = styled.div`
  text-align: center;
  margin-top: 88px;
  margin-bottom: 56px;
`

const Title = styled.h1`
  font-size: 44px;
  color: #393d7b;
  margin-bottom: 20px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  span {
    color: #ff6b4a;
  }
`

const Subtitle = styled.p`
  font-size: 18px;
  color: #777e90;
  font-weight: 400;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Pricing = () => {
  const pricingData: PricingCardProps[] = [
    {
      title: 'Unlimited',
      titleIcon: <Icon type="unlimited" />,
      monthlyPrice: 24.9,
      yearlyPrice: 19.9,
      originalYearlyPrice: 24.9,
      features: [
        {
          icon: <Icon type="gpt" />,
          name: 'GPT-4o mini',
        },
        {
          icon: <Icon type="claude" />,
          name: 'Claude 3 Haiku',
        },
      ],
      advancedModels: [
        {
          icon: <Icon type="gpt" />,
          name: 'GPT-4o mini',
        },
        {
          icon: <Icon type="claude" />,
          name: 'Claude 3 Haiku',
        },
        {
          icon: <Icon type="gemini" />,
          name: 'Gemini 1.5 Pro',
        },
        {
          icon: <Icon type="llama" />,
          name: 'Llama 3.1 405B',
        },
      ],
      description: 'Advanced model-driven smart writing, translation, summary',
      onSubscribe: () => console.log('Subscribe to Unlimited'),
    },
    {
      title: 'Pro',
      titleIcon: <Icon type="pro" />,
      monthlyPrice: 9.9,
      yearlyPrice: 7.9,
      originalYearlyPrice: 9.9,
      features: [
        {
          icon: <Icon type="gpt" />,
          name: 'GPT-4o mini',
        },
        {
          icon: <Icon type="claude" />,
          name: 'Claude 3 Haiku',
        },
      ],
      advancedModels: [
        {
          icon: <Icon type="gptBlack" />,
          name: 'GPT-4o mini',
        },
        {
          icon: <Icon type="claude" />,
          name: 'Claude 3 Haiku',
        },
        {
          icon: <Icon type="gemini" />,
          name: 'Gemini 1.5 Pro',
        },
        {
          icon: <Icon type="llama" />,
          name: 'Llama 3.1 405B',
        },
      ],
      description: 'Advanced model-driven smart writing, translation, summary',
      onSubscribe: () => console.log('Subscribe to Pro'),
    },
    {
      title: 'Free',
      titleIcon: <Icon type="free" />,
      monthlyPrice: 0,
      yearlyPrice: 0,
      features: [
        {
          icon: <Icon type="gpt" />,
          name: 'GPT-4o mini',
        },
        {
          icon: <Icon type="claude" />,
          name: 'Claude 3 Haiku',
        },
      ],
      advancedModels: [],
      description: 'Basic model-driven smart writing, translation, and summary',
      onSubscribe: () => console.log('Subscribe to Free'),
    },
  ]

  return (
    <PricingPage>
      <Header>
        <Slogan />
        {/* <div className="user-info">
                    <img src="/avatar.png" alt="User" />
                    <span>Jessica</span>
                </div> */}
      </Header>

      <Content>
        <Title>
          Explore <span>Creavo</span> annual plans
        </Title>
        <Subtitle>More Features. Lower Cost. Better Experience. Faster Response. Higher Efficiency.</Subtitle>
      </Content>

      <CardsContainer>
        {pricingData.map((plan) => (
          <PricingCard key={plan.title} {...plan} />
        ))}
      </CardsContainer>
    </PricingPage>
  )
}

export default Pricing
